module.exports = __webpack_public_path__ + "img/heshun.83125522.png";